import React, { createContext, useReducer, useEffect } from "react";

import authReducer from "./authReducer";
import axios from "axios";
import { useSnackbar } from "notistack";

export const AuthContext = createContext();

export default function AuthContextProvider(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [ifixit_admin_panel, dispatch] = useReducer(authReducer, {}, () => {
    const localData = localStorage.getItem("ifixit_admin_panel");
    return localData ? JSON.parse(localData) : {};
  });

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const handleLogout = async () => {
    try {
      let response = await axios({
        url: `/api/v1/user/logout`,
        method: "post",
        withCredentials: true, // 🔥 MUST
      });

      if (response.status >= 200 && response.status < 300) {
        // handleSnakbarOpen("Logged out successfully", "success");
      }
    } catch (error) {
      console.log("logout error", error);

      // handleSnakbarOpen("Logout failed", "error");
    }
  };
  const login = async (data) => {
    dispatch({
      type: "LOGIN",
      payload: data,
    });
  };

  const logout = () => {
    console.log("logout--------------------------");
    handleLogout();
    dispatch({
      type: "LOGOUT",
      payload: {},
    });
  };

  useEffect(() => {
    localStorage.setItem(
      "ifixit_admin_panel",
      JSON.stringify(ifixit_admin_panel),
    );
  }, [login]);

  return (
    <AuthContext.Provider value={{ login, ifixit_admin_panel, logout }}>
      {props.children}
    </AuthContext.Provider>
  );
}
